import { v4 as uuidv4 } from "uuid";
import { MAX_FILE_SIZE } from "../../config/Constant";
import { openNotificationError } from "../../utils/Utils";

const FileHandlerWrapper = ({
  children,
  className,
  innerRef,
  setUploadFiles,
  setIsOpenUploadModal,
  languageMap,
}) => {
  const handleFileChange = (e) => {
    const filesClipboardDataArray = Array.from(e.clipboardData.items).filter(
      (file) => file?.kind === "file",
    );

    if (filesClipboardDataArray?.length === 0) return;

    setIsOpenUploadModal(true);
    let totalSizeUpload = 0;

    const filesArray = filesClipboardDataArray.map((file) => {
      const f = file?.getAsFile();
      f.uid = uuidv4();
      totalSizeUpload += f?.size;
      return f;
    });

    if (totalSizeUpload > MAX_FILE_SIZE) {
      openNotificationError("File size exceeds the 1gb limit");
      return;
    }

    let encodeFiles = [];

    const readFilePromises = filesArray.map(
      (file) =>
        new Promise((resolve) => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (r) => {
            encodeFiles.push(file);

            resolve();
          };
        }),
    );

    Promise.all(readFilePromises).then(() => {
      setUploadFiles((prev) => [...prev, ...(encodeFiles || [])]);
    });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = async (event) => {
    event.preventDefault();

    const items = event.dataTransfer?.items;
    const files = event.dataTransfer?.files;

    if ((items && items.length > 0) || (files && files.length > 0)) {
      setIsOpenUploadModal(true);
    }

    // Check folder
    if (items && items.length > 0) {
      let hasFolder = false;

      for (let i = 0; i < items.length; i++) {
        const entry = items[i].webkitGetAsEntry?.();
        if (entry && entry.isDirectory) {
          hasFolder = true;
          break;
        }
      }

      if (hasFolder) {
        openNotificationError(
          languageMap?.["error.not.sendFolder"] ?? "You can not send folder",
        );
        setIsOpenUploadModal(false);
        return;
      }
    }

    if (!files || files.length === 0) {
      setIsOpenUploadModal(false);
      return;
    }

    const totalSizeUpload = Array.from(files).reduce(
      (sum, file) => sum + (file?.size || 0),
      0,
    );

    if (totalSizeUpload > MAX_FILE_SIZE) {
      openNotificationError("File size exceeds the 1GB limit");
      setIsOpenUploadModal(false);
      return;
    }

    const filesArray = Array.from(files).map((file) => {
      file.uid = uuidv4();
      return file;
    });

    try {
      const encodeFiles = await Promise.all(
        filesArray.map(
          (file) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);

              reader.onloadend = () => resolve(file);
              reader.onerror = reject;
            }),
        ),
      );
      setUploadFiles((prev) => [...prev, ...(encodeFiles || [])]);
    } catch (err) {
      console.error("Read file error:", err);
      openNotificationError("Failed to read file(s)");
    }
  };

  return (
    <div
      className={className}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onPaste={handleFileChange}
      ref={innerRef}
    >
      {children}
    </div>
  );
};

export default FileHandlerWrapper;
